import React, { useEffect, useState } from 'react';
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
} from 'recharts';
import { transformUserSourceData } from '../utils/transformAPIResponse';
import { Box } from '@mui/material';

// Component to render the user source chart
const UserSourceChart: React.FC<{
	apiResponse: AnalyticsApiResponse | null;
}> = ({ apiResponse }) => {
	const [userSourceData, setUserSourceData] = useState<UserSourceData[]>([]);

	useEffect(() => {
		if (!apiResponse) return;
		const transformedData = transformUserSourceData(apiResponse);
		setUserSourceData(transformedData);
	}, [apiResponse]);

	return (
		<Box sx={{ overflowX: 'auto', overflowY: 'hidden' }} mr={2}>
			<ResponsiveContainer width="100%" height={400} minWidth={1000}>
				<BarChart
					data={userSourceData}
					margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey="channel" />
					<YAxis
						dataKey="activeUsers"
						label={{
							value: '#Active Users',
							angle: -90,
							position: 'insideLeft',
						}}
					/>
					<Tooltip />
					<Bar dataKey="activeUsers" fill="#8884d8" />
				</BarChart>
			</ResponsiveContainer>
		</Box>
	);
};

export default UserSourceChart;
